module.exports = ["Project Manager","Construction Manager","Engineer","Supervisor","EHS","QAQC","General Worker","Welder","Fitter","Lifting Supervisor","Rigger man","Signalman","Operator","Electrician","Formwork worker","Formwork supervisor","Confined Space Supervisor","Confined Space Assesor","Confined Space Manager","Security","Commercial","Planner","Driver","Specialist","Trade Workers","IT","Management"]


//////////////////
// WEBPACK FOOTER
// ./static/userProfile/workerDesignation.json
// module id = ./static/userProfile/workerDesignation.json
// module chunks = 14